const conditions = () => {
  return [{ assetClass: { $ne: '' } }, { assetClass: 'object.asset-class.options.kapitalgeber' }]
}

export default conditions
